// src/AppRoutes.js
import { Navigate, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/HomePageOne";
import ViewProfilePageAdmin from "./pages/Admin Profile/ViewProfilePageAdmin";
import UsersListPage from "./pages/User/UsersListPage";
import SubadminListPage from "./pages/Subadmin/SubadminListPage";
import CreateSubadminPage from "./pages/Subadmin/CreateSubadminPage";
import UpdateSubadminPage from "./pages/Subadmin/UpdateSubadminPage";
import ViewSubadminPage from "./pages/Subadmin/ViewSubadminPage";
import ViewProfilePage from "./pages/User/ViewProfilePage";
import CreateUserPanelPage from "./pages/User/CreateUserPanelPage";
import EditUserPanelPage from "./pages/User/EditUserPanelPage";
import BrokerPage from "./pages/Broker/BrokerPage";
import TvChannelPage from "./pages/TvChannel/TvChannelPage";
import LedgerPage from "./pages/Accounts/LedgerPage";
import JVPage from "./pages/Accounts/JVPage";
import TrialBalancePage from "./pages/Accounts/TrialBalancePage";
import ErrorPage from "./pages/ErrorPage";
import { useAuth } from "./context/AuthContext";
import CashEntryPage from "./pages/Accounts/CashEntryPage";
import CashLedgerPage from "./pages/Accounts/CashLedgerPage";
import CreateQtyPage from "./pages/Settings/CreateQtyPage";
import ManageQtyPage from "./pages/Settings/ManageQtyPage";
import ListQtyPage from "./pages/Settings/ListQtyPage";
import BlockScriptsPage from "./pages/Settings/BlockScriptsPage";
import AccountTypePage from "./pages/Settings/AccountTypePage";
import TradesPage from "./pages/Trading/TradesPage";
import PendingTradesPage from "./pages/Trading/PendingTradesPage";
import PortfolioPositionPage from "./pages/Trading/PortfolioPositionPage";
import MarginManagementPage from "./pages/Trading/MarginManagementPage";
import SummaryReportPage from "./pages/Trading/SummaryReportPage";
import WatchlistPage from "./pages/Trading/WatchlistPage";
import TradeEditDeleteLogPage from "./pages/Utilities/TradeEditDeleteLogPage";
import CashEditDeleteLogPage from "./pages/Utilities/CashEditDeleteLogPage";
import MarketChartWithSocketIO from "./pages/Trading/MarketChartWithSocketIO";
import SegmentListPage from "./pages/TradingSettings/SegmentListPage";
import ScriptListPage from "./pages/TradingSettings/ScriptListPage";
import CMSManagementPage from "./pages/CMSManagementPage";
import CMSViewPage from "./pages/CMSViewPage";
import CMSUpdatePage from "./pages/CMSUpdatePage";
import UserEditLogPage from "./pages/Utilities/UserEditLogPage";
import RejectionLogPage from "./pages/Utilities/RejectionLogPage";
import AutoSquareOffLogPage from "./pages/Utilities/AutoSquareOffLogPage";
import CommissionRevenuePage from "./pages/Trading/CommissionRevenuePage";
import ReportsAnalyticsPage from "./pages/Trading/ReportsAnalyticsPage";
import SystemConfigPage from "./pages/Settings/SystemConfigPage";
import SettlementManagementPage from "./pages/Accounts/SettlementManagementPage";
import MasterLayout from "./masterLayout/MasterLayout";
import WhiteLabelsPage from "./pages/WhiteLabelsPage";

// Placeholders for remaining sidebar items
const WalletPlaceholder = () => <LedgerPage title="Wallet & Funds" />;

function AppRoutes() {
  const { subAdminId, profile } = useAuth();
  const isSuperAdmin = profile?.role === "SUPERADMIN";

  // Redirect Super Admin users back to white labels page if they try to access standard admin pages
  const adminRoute = (element) => {
    return element;
  };

  return (
    <Routes>
      <Route path="/dashboard" element={adminRoute(<HomePageOne />)} />
      <Route
        path="/white-labels"
        element={
          profile?.role === "SUPERADMIN" ? (
            <WhiteLabelsPage />
          ) : (
            <Navigate to="/dashboard" replace />
          )
        }
      />
      <Route path="/view-admin-profile"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<ViewProfilePageAdmin />)
          )
        }
      />
      <Route path="/view-user-profile/:id" element={adminRoute(<ViewProfilePage />)} />
      <Route path="/edit-user-profile/:id" element={adminRoute(<EditUserPanelPage />)} />
      <Route path="/user-panel/create" element={adminRoute(<CreateUserPanelPage />)} />
      <Route path="/users-list" element={adminRoute(<UsersListPage />)} />

      <Route
        path="/subadmin-list"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<SubadminListPage />)
          )
        }
      />
      <Route
        path="/subadmin-create"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<CreateSubadminPage />)
          )
        }
      />
      <Route
        path="/subadmin-update/:id"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<UpdateSubadminPage />)
          )
        }
      />
      <Route
        path="/subadmin-view/:id"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<ViewSubadminPage />)
          )
        }
      />

        // for subadmin profile view
      <Route
        path="/my-profile"
        element={
          subAdminId ? (
            <ViewSubadminPage />
          ) : (
            <Navigate to="/dashboard" replace />
          )
        }
      />

      <Route path="/broker-list" element={adminRoute(<BrokerPage />)} />
      <Route
        path="/tv-channel-list"
        element={
          subAdminId ? <Navigate to="/dashboard" replace /> : adminRoute(<TvChannelPage />)
        }
      />

      <Route path="/accounts/ledger" element={adminRoute(<LedgerPage />)} />
      <Route
        path="/accounts/cash-ledger"
        element={adminRoute(<CashLedgerPage title="Cash Ledger" />)}
      />
      <Route
        path="/accounts/cash-entry"
        element={adminRoute(<CashEntryPage title="Cash Entry" />)}
      />
      <Route path="/accounts/jv" element={adminRoute(<JVPage />)} />
      <Route path="/accounts/trial-balance" element={adminRoute(<TrialBalancePage />)} />
      <Route
        path="/accounts/settlement-management"
        element={adminRoute(<SettlementManagementPage />)}
      />


      <Route
        path="/settings/create-qty"
        element={
          subAdminId ? <Navigate to="/dashboard" replace /> : adminRoute(<CreateQtyPage />)
        }
      />
      <Route
        path="/settings/manage-qty"
        element={
          subAdminId ? <Navigate to="/dashboard" replace /> : adminRoute(<ManageQtyPage />)
        }
      />
      <Route
        path="/settings/list-qty"
        element={
          subAdminId ? <Navigate to="/dashboard" replace /> : adminRoute(<ListQtyPage />)
        }
      />
      <Route
        path="/settings/block-scripts"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<BlockScriptsPage />)
          )
        }
      />
      <Route
        path="/settings/account-type"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<AccountTypePage />)
          )
        }
      />

      <Route
        path="/trading-settings/segments"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<SegmentListPage />)
          )
        }
      />
      <Route
        path="/trading-settings/scripts-list"
        element={
          subAdminId ? <Navigate to="/dashboard" replace /> : adminRoute(<ScriptListPage />)
        }
      />
      <Route
        path="/cms-management"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(<CMSManagementPage />)
          )
        }
      />
      <Route
        path="/cms-management/view/:id"
        element={
          subAdminId ? <Navigate to="/dashboard" replace /> : adminRoute(<CMSViewPage />)
        }
      />
      <Route
        path="/cms-management/update/:id"
        element={
          subAdminId ? <Navigate to="/dashboard" replace /> : adminRoute(<CMSUpdatePage />)
        }
      />

      <Route path="/trading/trades" element={adminRoute(<TradesPage />)} />
      <Route path="/trading/pending-trades" element={adminRoute(<PendingTradesPage />)} />
      <Route path="/trading/portfolio" element={adminRoute(<PortfolioPositionPage />)} />
      <Route
        path="/trading/margin-management"
        element={adminRoute(<MarginManagementPage />)}
      />
      <Route path="/trading/summary-report" element={adminRoute(<SummaryReportPage />)} />
      <Route path="/trading/watchlist" element={adminRoute(<WatchlistPage />)} />
      {/* <Route
        path="/trading/market-data"
        element={<MarketChartWithSocketIO />}
      /> */}
      <Route
        path="/utilities/trade-edit-delete-log"
        element={adminRoute(<TradeEditDeleteLogPage />)}
      />
      <Route path="/utilities/user-edit-log" element={adminRoute(<UserEditLogPage />)} />
      <Route
        path="/utilities/cash-edit-delete-log"
        element={adminRoute(<CashEditDeleteLogPage />)}
      />
      <Route
        path="/utilities/auto-squareup-log"
        element={adminRoute(<AutoSquareOffLogPage />)}
      />
      <Route path="/utilities/rejection-log" element={adminRoute(<RejectionLogPage />)} />

      {/* New Revenue & Analytics Routes */}
      <Route path="/commission-revenue" element={adminRoute(<CommissionRevenuePage />)} />
      <Route path="/reports-analytics" element={adminRoute(<ReportsAnalyticsPage />)} />
      <Route path="/wallet-funds" element={adminRoute(<WalletPlaceholder />)} />

      <Route
        path="/system-config"
        element={
          subAdminId ? (
            <Navigate to="/dashboard" replace />
          ) : (
            adminRoute(
              <MasterLayout>
                <SystemConfigPage />
              </MasterLayout>
            )
          )
        }
      />
      <Route path="*" element={<ErrorPage />} />
    </Routes>
  );
}

export default AppRoutes;
